import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import { Edit, DeleteOutline } from "@mui/icons-material";
import { Staff } from "../types/staff";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";
import Image from "src/shared/Image";

interface StaffTableProps {
  staffData: Staff[];
  filteredData: Staff[];
  onEdit: (staff: Staff) => void;
  onDelete: (id: string, name: string) => void;
  showDeletedStaffs: boolean;
}

const StaffTable: React.FC<StaffTableProps> = ({ filteredData, onEdit, onDelete, showDeletedStaffs }) => {

  const headCells: HeadCell<any>[] = [
    { id: "sno", label: "S.No" },
    { id: "staff_name", label: "Staff Name" },
    { id: "phone_number", label: "Phone Number" },
    { id: "staff_image_key", label: "Image" },
    { id: "actions", label: "Actions" },
  ];

  const tableData = filteredData.map((staff, index) => ({
    id: staff._id?.$oid || index,
    sno: index + 1,
    staff_name: staff.staff_name,
    phone_number: staff.phone_number,
    staff_image_key: <div className="w-[60px] h-[60px] flex justify-center items-center object-contain overflow-hidden"><Image imagePath={staff.staff_image_key} /></div>,
    actions: (
      <div className="flex gap-1">
        <Tooltip title="Edit" placement="bottom" arrow>
          <span>
            <IconButton
              size="small"
              disabled={showDeletedStaffs}
              onClick={(e) => {
                e.stopPropagation();
                if (!showDeletedStaffs) onEdit(staff);
              }}
            >
              <Edit style={{ color: showDeletedStaffs ? "gray" : "black" }} />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Delete" placement="bottom" arrow>
          <span>
            <IconButton
              size="small"
              disabled={showDeletedStaffs}
              onClick={(e) => {
                e.stopPropagation();
                if (!showDeletedStaffs) onDelete(staff._id?.$oid, staff.staff_name);
              }}
            >
              <DeleteOutline style={{ color: showDeletedStaffs ? "lightgray" : "red" }} />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    ),
  }));

  // ✅ Render
  return <CommonTable title="Staff List" data={tableData} headCells={headCells} selectable={false} showFilterIcon={false} showToolbar={false} theme={true} pageSize={5} pagenation={true} />;
};

export default StaffTable;
